export const FORGOT_PASSWORD_INITIAL_FORM_STATE = {
  email: '',
};

export const FORGOT_PASSWORD_INITIAL_CODE_STATE = {
  type: '',
  count: 0,
  context: {},
};

export const INVALID_FORM = 'invalid-form';
export const INTERNAL_SERVER_ERROR = 'internal-server-error';
export const TOO_MANY_ATTEMPTS = 'too-many-attempts';
